import { forwardRef, useImperativeHandle, useState } from "react"
import { createPortal } from "react-dom"

import { Space, Typography } from "antd"

import { INCOGNITO_MASK } from "../../../../Components/Private"
import { useIncognito } from "../../../../hooks/useIncognito"
import { formatCurrency } from "../../../../Utils/utils"

import "./ChartTooltip.less"

const { Text } = Typography

const ChartTooltip = forwardRef(({ dataType }, ref) => {
  const [payload, setPayload] = useState(null)

  useImperativeHandle(
    ref,
    () => ({
      update: (p) => {
        setPayload(p)
      }
    }),
    []
  )

  return createPortal(<TooltipContent {...payload} dataType={dataType} />, document.body)
})

const TooltipContent = ({ x, y, value, date, dataType, visible = false }) => {
  const incognito = useIncognito()
  const style = {
    top: y,
    left: x,
    opacity: visible ? 1 : 0
  }

  return (
    <div id="referral-reward-chart-tooltip" style={style}>
      <Space direction="vertical" size={4}>
        <span className="tooltip-date">{date}</span>
        <span>
          {dataType === "volume"
            ? incognito
              ? INCOGNITO_MASK
              : formatCurrency(value)
            : value}
        </span>
      </Space>
    </div>
  )
}

export default ChartTooltip
